import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class XirrService {
  private readonly data: {
    [key: string]: { [key: number]: number };
  } = {
    AVANS: {
      15: 2993.53,
      16: 2947.21,
      17: 2900.72,
      18: 2855.17,
      19: 2811.77,
      20: 2768.92,
      21: 2728.27,
      22: 2688.74,
      23: 2649.5,
      24: 2609.29,
      25: 2574.03,
      26: 2536.65,
      27: 2502.0,
      28: 2466.34,
      29: 2433.84,
      30: 2397.89,
    },
    FINBAR: {
      15: 2993.53,
      16: 2947.21,
      17: 2900.72,
      18: 2855.17,
      19: 2811.77,
      20: 2768.92,
      21: 2728.27,
      22: 2688.74,
      23: 2649.5,
      24: 2609.29,
      25: 2574.03,
      26: 2536.65,
      27: 2502.0,
      28: 2466.34,
      29: 2433.84,
      30: 2397.89,
    },
    CREDISEND: {
      15: 2993.53,
      16: 2947.21,
      17: 2900.72,
      18: 2855.17,
      19: 2811.77,
      20: 2768.92,
      21: 2728.27,
      22: 2688.74,
      23: 2649.5,
      24: 2609.29,
      25: 2574.03,
      26: 2536.65,
      27: 2502.0,
      28: 2466.34,
      29: 2433.84,
      30: 2397.89,
    },
    SUNCREDIT: {
      15: 3035.72,
      20: 2806.79,
      25: 2625.33,
      30: 2428.9,
    },
    STARFIN: {
      15: 3035.72,
      20: 2806.79,
      25: 2625.33,
      30: 2428.9,
    },
  };

  public getXirr(name: string, term: number): number {
    return this.data[name][term];
  }
}
